export default {
    newDesign: true,
    title:
        "¿Quiere saber cuánto podrá ganar su hijo/a en el futuro? | Kodland",
    downtimeUrl: "http://kodland.org/es",
    parameters: {
        landing_id: "EsQuFJ",
        segment: 14,
        success_page: "success_long",
    },
    startPage: {
        title:
            "Responda a las preguntas y reciba una guía lista para construir un futuro exitoso para su hijo/a.",
        subtitle:
            "✔️ Elaborado por expertos en educación<br>❤️ Completamente gratuito<br>👪 Más de 100 mil padres confían en nosotrosf",
        image: {
            url: "/welcome/es_content_future_job_desk.png",//ждем дизайн
            style: {
                height: "100%",
                "max-height": "100vh",
            },
        },
        imageMobile: {
            url: "/welcome/es_content_future_job_mob.png",//ждем дизайн
            style: {
                width: "100%",
            },
        },
        button: "Empezar",
    },
    stopPage: {
        image: "/welcome/quizV2/no-computer.png",
        title: "¡Gracias por confiar en nuestra plataforma educativa!",
        subtitle:
            "Desafortunadamente, las tabletas o los teléfonos no son adecuados para tomar nuestras lecciones. ¡Estaremos felices de verlos en nuestras clases la próxima vez!",
    },
    quizRotateBySteps: {
        1: {
            title: "¿Qué edad tiene tu hijo/a?",
            type: "age",
            button: "",
        },
        2: {
            question:
                "¿Tienes una computadora de escritorio o portátil en la que tu hijo puede jugar o estudiar?",
            answers: [
                "Sí, tiene su propio dispositivo 💻✅",
                "Sí, pero lo comparte con otros 🖥️👫",
                {
                    answer: "No, no tiene acceso regular 🚫",
                    stopAnswer: true,
                },
            ],
        },
        3: {
            question: "¿Cuánto tiempo usa tu hijo dispositivos al día?",
            answers: [
                "Menos de una hora 🕒",
                "1-2 horas 📱",
                "3-4 horas 💻",
                "Más de 5 horas ⏳",
                "No usa dispositivos 🚫"
            ],
        },
        4: {
            dynamicTypeInfo: [
                {
                    condition: [{ step: 3, answer: "Menos de una hora 🕒" }],
                    data: {
                        typeInfo: "noQuestions",
                        imageLink: "/welcome/review_es.png",
                        subtitle:
                            "¡Felicidades! Tu hijo cumple con el estándar recomendado a nivel mundial. Al final del test, te daremos consejos para que el tiempo frente a la pantalla sea productivo.",
                        button: "Entendido ✅",
                    },
                },
                {
                    condition: [{ step: 3, answer: "1-2 horas 📱" }],
                    data: {
                        typeInfo: "noQuestions",
                        imageLink: "/welcome/review_es.png",
                        subtitle:
                            "¡Felicidades! Tu hijo cumple con el estándar recomendado a nivel mundial. Al final del test, te daremos consejos para que el tiempo frente a la pantalla sea productivo.",
                        button: "Entendido ✅",
                    },
                },
                {
                    condition: [{ step: 3, answer: "3-4 horas 💻" }],
                    data: {
                        typeInfo: "noQuestions",
                        imageLink: "/welcome/review_es.png",
                        subtitle:
                            "Actualmente, se recomienda que los niños de 8 a 17 años pasen no más de 1-2 horas al día frente a una pantalla. Al final del test, te daremos consejos para hacer que ese tiempo sea productivo.",
                        button: "Entendido ✅",
                    },
                },
                {
                    condition: [{ step: 3, answer: "Más de 5 horas ⏳" }],
                    data: {
                        typeInfo: "noQuestions",
                        imageLink: "/welcome/review_es.png",
                        subtitle:
                            "Actualmente, se recomienda que los niños de 8 a 17 años pasen no más de 1-2 horas al día frente a una pantalla. Al final del test, te daremos consejos para hacer que ese tiempo sea productivo.",
                        button: "Entendido ✅",
                    },
                },
                {
                    condition: [{ step: 3, answer: "No usa dispositivos 🚫" }],
                    data: {
                        typeInfo: "noQuestions",
                        imageLink: "/welcome/review_es.png",
                        subtitle:
                            "La computadora y el smartphone son parte fundamental de la vida moderna, el aprendizaje y la carrera profesional, incluso si a veces parecen perjudiciales para los niños. Al final del test, te daremos consejos para que su tiempo frente a la pantalla sea productivo.",
                        button: "Entendido ✅",
                    },
                },
            ],
        },
        5: {
            question:
                "¿Tu hijo se siente cómodo usando tecnología como computadoras, aplicaciones o tareas básicas en internet?",
            answers: [
                "Muy cómodo, usa seguido 💻",
                "Tareas básicas, con ayuda 📱",
                "No está familiarizado 🚫",
            ],
        },
        6: {
            question:
                "¿Qué suele hacer tu hijo/a con el ordenador, el móvil o la tablet?",
            answers: [
                "Juega a videojuegos 🎮",
                "Ve dibujos animados 📺",
                "Usa redes sociales 📱",
                "Usa los dispositivos para estudiar 📚",
                "No usa dispositivos electrónicos 🚫",
            ],
        },
        7: {
            question:
                "¿Qué le interesa a tu hijo/a en el mundo real?",
            answers: [
                "Practica deportes o juega al aire libre ⚽",
                "Participa en actividades creativas 🎨",
                "Lee libros o cómics 📚",
                "Pasa tiempo con amigos o en familia 👫",
                "Otro 🙂",
            ],
        },
        8: {
            question:
                "¿Qué materias son más difíciles para tu hijo/a en la escuela?",
            answers: [
                "Técnicas 🛠️",
                "Creativas 🎨",
                "Sociales 🧑‍🤝‍🧑",
                "Relacionadas con la actividad física 🏃",
                "No estoy seguro/a ❓",
            ],
        },
        9: {
            question:
                "¿Cómo es su rendimiento académico?",
            answers: [
                "Alumno destacado 🏅",
                "Buen estudiante 👍",
                "Promedio 📚",
            ],
        },

        10: {
            typeInfo: "noQuestions",
            imageLink: "/welcome/latam_coding_habilities_q9.png",
            subtitle:
                "¿Sabías que el éxito futuro no depende de las calificaciones escolares? ¡Lo más importante es desarrollar el potencial de tu hijo/a a través de sus intereses! Al final del test, descubrirás cómo lograrlo.",
            button: "¡Perfecto!",

        },
        11: {
            question: "¿Tu hijo sabe qué quiere ser cuando crezca?",
            answers: [
                "Sí, ya ha elegido una profesión 👩‍⚖️",
                "No, aún no lo ha pensado 🤷‍♂️",
                "Tiene muchas opciones en mente 🎨⚽",
                "No estoy seguro/a 🤷‍♀️",
            ],
        },
        12: {
            typeInfo: "noQuestions",
            title: "¡Gracias por completar el test!",
            subtitle:
                "🎯Según tus respuestas, hemos calculado el salario que tu hijo/a podría ganar en el futuro. ¡Descubre esta cifra y cómo alcanzarla!",
            button: "Ver el resultado",
        },
        13: {
            dynamicTypeInfo: [
                {
                    condition: [{ step: 5, answer: "No está familiarizado 🚫" }],
                    data: {
                        typeInfo: "noQuestions",
                        title: "Desde $10,000 al año 🚀",
                        subtitle:
                            "✨ Estamos convencidos de que tu hijo puede construir una carrera exitosa en el futuro. Para lograrlo, es fundamental acercarlo al mundo de la tecnología y los gadgets. Aunque a veces puedan parecer dañinos para los niños, las habilidades en computación y en el uso de diferentes programas son la base para un trabajo bien remunerado.<br>Nosotros sabemos cómo introducir a los niños en el entorno digital de manera segura, responsable y respetando sus intereses. ",
                        button: "Recibir mi regalo 🎁",
                    },
                },
                {
                    condition: [{ step: 8, answer: "No estoy seguro/a ❓" }],
                    data: {
                        typeInfo: "noQuestions",
                        title: "Desde $10,000 al año 🚀",
                        subtitle:
                            "✨ Estamos convencidos de que tu hijo puede construir una carrera exitosa en el futuro. Para lograrlo, es fundamental acercarlo al mundo de la tecnología y los gadgets. Aunque a veces puedan parecer dañinos para los niños, las habilidades en computación y en el uso de diferentes programas son la base para un trabajo bien remunerado.<br>Nosotros sabemos cómo introducir a los niños en el entorno digital de manera segura, responsable y respetando sus intereses. ",
                        button: "Recibir mi regalo 🎁",
                    },
                },
                {
                    condition: [{ step: 5, answer: "Tareas básicas, con ayuda 📱" }],
                    data: {
                        typeInfo: "noQuestions",
                        title: "Desde $30,000 al año 🚀",
                        subtitle:
                            "🌟 Sin duda, tienes un niño talentoso que podrá construir una carrera bastante exitosa en el futuro. Pero para alcanzar aún más, te recomendamos guiar los intereses de tu hijo hacia profesiones con futuro prometedor. ¡Puedes hacerlo desde hoy!",
                        button: "Recibir mi regalo 🎁",
                    },
                },
                {
                    condition: [{ step: 6, answer: "No usa dispositivos electrónicos 🚫" }],
                    data: {
                        typeInfo: "noQuestions",
                        title: "Desde $30,000 al año 🚀",
                        subtitle:
                            "🌟 Sin duda, tienes un niño talentoso que podrá construir una carrera bastante exitosa en el futuro. Pero para alcanzar aún más, te recomendamos guiar los intereses de tu hijo hacia profesiones con futuro prometedor. ¡Puedes hacerlo desde hoy!",
                        button: "Recibir mi regalo 🎁",
                    },
                },
                {
                    condition: [{ step: 8, answer: "Creativas 🎨" }],
                    data: {
                        typeInfo: "noQuestions",
                        title: "Desde $30,000 al año 🚀",
                        subtitle:
                            "🌟 Sin duda, tienes un niño talentoso que podrá construir una carrera bastante exitosa en el futuro. Pero para alcanzar aún más, te recomendamos guiar los intereses de tu hijo hacia profesiones con futuro prometedor. ¡Puedes hacerlo desde hoy!",
                        button: "Recibir mi regalo 🎁",
                    },
                },
                {
                    condition: [{ step: 8, answer: "Sociales 🧑‍🤝‍🧑" }],
                    data: {
                        typeInfo: "noQuestions",
                        title: "Desde $30,000 al año 🚀",
                        subtitle:
                            "🌟 Sin duda, tienes un niño talentoso que podrá construir una carrera bastante exitosa en el futuro. Pero para alcanzar aún más, te recomendamos guiar los intereses de tu hijo hacia profesiones con futuro prometedor. ¡Puedes hacerlo desde hoy!",
                        button: "Recibir mi regalo 🎁",
                    },
                },
                {
                    condition: [{ step: 8, answer: "Relacionadas con la actividad física 🏃" }],
                    data: {
                        typeInfo: "noQuestions",
                        title: "Desde $30,000 al año 🚀",
                        subtitle:
                            "🌟 Sin duda, tienes un niño talentoso que podrá construir una carrera bastante exitosa en el futuro. Pero para alcanzar aún más, te recomendamos guiar los intereses de tu hijo hacia profesiones con futuro prometedor. ¡Puedes hacerlo desde hoy!",
                        button: "Recibir mi regalo 🎁",
                    },
                },
                {
                    default: true,
                    data: {
                        typeInfo: "noQuestions",
                        title: "Desde $60,000 al año 🚀",
                        subtitle:
                            "🎉 ¡Felicidades! Tu hijo tiene una gran predisposición para las profesiones del futuro. Su dominio de la tecnología y su interés por los gadgets pueden ser una base sólida para una carrera en programación, análisis de datos, redes neuronales. Y te invitamos a dar el siguiente paso.",
                        button: "Recibir mi regalo 🎁",
                    },
                },
            ],
        },
        14: {
            typeInfo: "noQuestions",
            imageLink: "/welcome/es_content_distraction_paid_q15.png",
            title: "🎁 Regalo por completar el test: una clase gratuita en Kodland",
            subtitle:
                "🧠 Desarrolla el pensamiento lógico y la creatividad creando juegos.<br>🗣️ Tu hijo aprenderá a trabajar en equipo y mejorará sus habilidades de comunicación.<br>💪 Fomentará su independencia y autoconfianza.<br>💼 Se preparará para una profesión con futuro.",
            button: "Inscribirse en la clase",
        },
        15: {
            title: "Inscríbete a una clase de prueba gratuita",
            type: "one-page-contacts",
            subtitle:
                "Conversemos, conoce nuestro método y descubre todo lo que tu hijo puede aprender con nosotros.",
            button: "Elige una fecha ➡️",
        },
        16: {
            title: "",
            type: "timeslot",
            subtitle: "",
            button: "",
        },
        17: {
            title: "Revisa estos detalles para completar el registro ✨",
            typeInfo: "pc-laptop",
            subtitle:
                "Ten en cuenta que para la lección necesitaras una PC o laptop en funcionamiento y que deberás acompañar a tu hijo/a durante toda la clase. Recuerda que la misma es individual y personalizada.",
            button: "¿Qué más?",
        },
        18: {
            title: "Chequea tu correo y WhatsApp antes de la clase de prueba📞",
            typeInfo: "whatsapp",
            subtitle:
                "24hs antes estaremos enviándote un recordatorio y 2 horas antes de la clase te pediremos que confirmes tu asistencia. Es muy importante que estemos en contacto para que la clase no se cancele.",
            button: "¿Qué más?",
        },
        19: {
            title: "La clase se realizará en nuestra plataforma 💻",
            typeInfo: "classroom",
            subtitle:
              "Recibirás un enlace y un código único por WhatsApp y correo electrónico. Solo haz clic en el enlace y te llevará directo a la clase. Sin apps adicionales, sin descargas.",
            button: "Entendido ✅",
        },
    },
};

// Ждём дизайн => Добавить обложки и добавить import в quiz.js